import React from "react";
import styled from "styled-components";
import dotenv from "dotenv";
import cloudinary from "cloudinary";
import * as contentful from "contentful-management";
import Dropzone from "react-dropzone";
import request from "superagent";
import { connect, } from "react-redux";
import R from "ramda";

import env from "../vars";
import { promiseLog as log, } from "../lib/util";

// --------------------------------------------------

const Button = styled.div`
	width: 100px;
	height: 100px;
	background: #ddd;
`;

const Container = styled.div`
	width: 100%;
`

const ImagesContainer = styled.div`
	width: 100%;
	padding: 10px;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
`;

const ImageBox = styled.div`
	width: 500px;
	height: 400px;
	background: ${p => p.error ? "red" : "#eee"};
	margin: 10px;
	padding: 10px;
	font-size: 10px;
`;

const ImagePreview = styled.div`
	width: 100%;
	padding-top: 50%;
	background-color: black;
	background-size: cover;
	background-position: center center;
	${p => p.src ? `background-image: url(${p.src});` : ""}
	margin-bottom: 10px;
`;

const FormGroup = styled.div`
	margin-bottom: 10px;
`;

const Label = styled.div`
	text-transform: uppercase;
	font-weight: bold;
`;

const Input = styled.input`
	display: block;
	width: 100%;
	padding: 0.2em;
`;

const SaveButton = styled.div`
	position: fixed;
	bottom: 20px;
	right: 20px;
	background-color: lightgreen;
	color: white;
	padding: 10px;
	font-size: 20px;

	&:before {
		content: "SAVE CHANGES";
	}
`;

// --------------------------------------------------

// const client = contentful.createClient({
// 	accessToken: env.CONTENTFUL_ACCESS_TOKEN,
// });
const lang = "en-US";

// --------------------------------------------------

// const foo = () => {
// 	console.log("click");
// 	console.log(client);

// 	client.getSpace(env.CONTENTFUL_SPACE_ID)
// 	.then(log("lol"))

// 	// const space = await client.getSpace(env.CONTENTFUL_SPACE_ID);

// 	// console.log(space);
// 	// .then(space => space.getContentTypes())
// 	// .then(contentTypes => console.log(contentTypes))
// }

// --------------------------------------------------


class ImageUpload extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			images: {},
			space: props.space,
		};

		console.log("props in constructor", props);

		// { preview, cloudinaryUrl, asset, entry, error, }

		// client.getSpace(env.CONTENTFUL_SPACE_ID)
		// .then(space => {
		// 	this.setState({ space, });
		// 	return space;
		// });

		[ "onClickButton", "onDrop", "upload", "setImage", "titleChange", "tagsChange", "saveChanges", ]
		.forEach(name => { this[name] = this[name].bind(this) })
		// this.onClickButton = this.onClickButton.bind(this);
		// this.onDrop = this.onDrop.bind(this);
	}

	onClickButton() {
		this.state.space.createAsset({
			fields: {
				file: {
					"en-US": {
						contentType: "image/jpeg",
						fileName: "spongebob.jpg",
						upload: "https://img.buzzfeed.com/buzzfeed-static/static/2016-06/3/13/asset/buzzfeed-prod-fastlane03/sub-buzz-7125-1464974872-3.jpg",
					},
				},
			},
		})
		.then(asset => asset.processForAllLocales())
		// .then(asset => asset.publish())
		.then(log("asset"))
		// .then(asset => (
		// 	new Promise(resolve => { setTimeout(resolve, 5000) })
		// 	.then(() => asset)
		// ))
		.then(asset => this.state.space.createEntry("gallery-image", {
			fields: {
				title: {
					"en-US": "spongebob",
				},
				image: {
					"en-US": {
						sys: {
							type: "Link",
							linkType: "Asset",
							"id": asset.sys.id,
						},
					},
				},
			},
		}))
		// .then(entry => entry.publish()) // doesnt work if you publish the entry straight away
		.then(log("entry"))
	}

	onDrop(files) {
		console.log({ files, });
		files.forEach(file => this.upload(file));
	}

	setImage(name, obj) {
		const s = prevState => ({
			images: {
				...prevState.images,
				[name]: {
					...prevState.images[name],
					...obj,
				},
			},
		});
		this.setState(s);
	}

	upload(file) {
		const si = o => this.setImage(file.name, o);
		si({ preview: file.preview, });

		request.post(env.CLOUDINARY_UPLOAD_URL)
		.field("upload_preset", env.CLOUDINARY_UPLOAD_PRESET)
		.field("file", file)
		// .end((err, res) => {
		// 	if (!err & res.body.secure_url.length) {
		// 		si({ cloudinaryUrl: res.body.secure_url, });
		// 		return res.body.secure_url;
		// 	}
		// 	else {
		// 		console.error("cloudinary error", err);
		// 		si({ error: true, });
		// 		throw new Error("cloudinary error");
		// 	}
		// })
		.then(res => {
			if (res.body.secure_url.length) {
				si({ cloudinaryUrl: res.body.secure_url, });
				return res.body.secure_url;
			}
			else {
				console.error("cloudinary error");
				si({ error: true, });
				throw new Error("cloudinary error");
			}
		})
		.then(url => this.state.space.createAsset({
			fields: {
				file: {
					[lang]: {
						contentType: "image/jpeg",
						fileName: file.name,
						upload: url,
					},
				},
			},
		}))
		.then(asset => {
			si({ asset, });
			return asset.processForAllLocales();
		})

		.then(asset => this.state.space.createEntry("gallery-image", {
			fields: {
				title: {
					[lang]: file.name,
				},
				tags: {
					[lang]: [],
				},
				image: {
					[lang]: {
						sys: {
							type: "Link",
							linkType: "Asset",
							"id": asset.sys.id,
						},
					},
				},
			},
		}))
		.then(entry => {
			console.log("entry", entry);
			if (!entry.fields.tags) {
				entry.fields.tags = {
					[lang]: [],
				};
			}
			si({ entry, });
			return entry;
		})
	}

	titleChange(name) {
		return (e) => {
			const entry = this.state.images[name].entry;
			entry.fields.title[lang] = e.target.value;
			this.setImage(name, { entry, });
		}
	}

	tagsChange(name) {
		return (e) => {
			const entry = this.state.images[name].entry;
			entry.fields.tags[lang] = this.getTags(e.target.value);
			this.setImage(name, { entry, });
		}
	}

	getTags(tagString) {
		return (tagString || "").split(", ");
	}

	getTagString(tags) {
		return tags.join(", ");
	}

	saveChanges() {
		console.log("saving changes");
		Object.values(this.state.images).forEach(image => {
			if (image.entry) {
				image.entry.update();
			}
		})
	}

	render() {
		// console.log({ state: this.state, });
		const images = (
			Object.keys(this.state.images)
			.map(key => ({
				...this.state.images[key],
				name: key,
			}))
		);
		// console.table(images);

		return (
			<Container>
				{
					images.length
						? (
							<div>
								<ImagesContainer>
									{
										images.map((image, i) => (
											<ImageBox
												key = { i }
												error = { image.error }
											>
												<ImagePreview src = { image.preview } />
												{ console.log("image", image) }

												{
													image.entry
														? (
															<div>
																<FormGroup>
																	<Label>Title</Label>
																	<Input	
																		type = "text"
																		value = { R.path([ "entry", "fields", "title", lang, ])(image) }
																		onChange = { this.titleChange(image.name) }
																	/>
																</FormGroup>
																<FormGroup>
																	<Label>Tags</Label>
																	<Input	
																		type = "text"
																		value = { R.path([ "entry", "fields", "tags", lang, ])(image) }
																		onChange = { this.tagsChange(image.name) }
																	/>
																</FormGroup>
															</div>
														)
														: null
												}
											</ImageBox>
										))
									}
								</ImagesContainer>
								<SaveButton
									onClick = { this.saveChanges }
								/>
							</div>
						)
						: (
							this.state.space
								? (
									<Dropzone
										accept = "image/*"
										onDrop = { this.onDrop }
									>
										<div>dropit</div>
									</Dropzone>
								)
								: null
						)
				}				
			</Container>
		)
	}
};

export default connect(o => o)(ImageUpload);


// WEBPACK FOOTER //
// ./src/components/ImageUpload.js